import qwest from 'qwest';

let supportApi = {
  contact(type, name, email, phone, store, subject, content, url, screenshot, system, version, OSVersion, systemID, logs) {
    return new Promise((resolve, reject) => {
      qwest.post('/Support/Ticket', {
        type,
        name,
        email,
        phone,
        store,
        subject,
        content,
        url,
        screenshot,
        system,
        version,
        OSVersion,
        systemID,
        logs,
      })
      .then((xhr, response) => {
        if (response.success) {
          resolve(response.data);
        } else {
          reject(response);
        }
      });
    });
  },
};

export default supportApi;
